// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__ShO8K","approved":"Status_approved__3wuo-","rejected":"Status_rejected__hIGMH","expired":"Status_expired__3BwmS","label":"Status_label__EauY5"};